import styled, { css } from "styled-components";

const CurrentStatusPillStyled = styled.div`
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        height: 28px;
        padding-top: 2px;
        border-radius: 5px;
        position: relative;
        font-size: 1.2rem;
            font-weight: 400;
            color: #757575;


        .color {
            width: 8px;
            height: 8px;
            margin-top: 2px;
            border-radius: 100%;
            background: ${props => props.statusColor}
        }

   ${props => {
        return (
            props.selected &&
            css`
                .title {
                    color: #3D4543;
                }   
     
            `
        );
    }}

${props => {
        return (
            props.hasBackground &&
            css`
            padding: 4px 8px;
            flex-direction: row-reverse;
               ::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: ${props.statusColor};
                    opacity: 0.15;
                    border-radius: 5px;
                }
                
            `
        );
    }}    


`

export { CurrentStatusPillStyled };